var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue, isVariable } from '../../../../Fct/generics';
import { getAllCurrencies, getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../constants';
import { getIsNative } from '../helpers/getToken';
import { Uniswap } from '../helpers/Uniswap';
import { AddLiquidity } from './addLiquidity';
import { AddLiquidityETH } from './ETH/addLiquidityETH';
import { BigNumber } from 'bignumber.js';
export var SimpleAddLiquidity = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'addLiquidity',
    description: 'Add liquidity on Uniswap',
    name: 'simpleAddLiquidity',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    currencyA: new FctAddress({ destination: 'erc20', options: getAllCurrencies({ chainId: chainId }) }),
                    currencyB: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    amountADesired: new FctValue({ destination: 'wei_amount' }),
                    amountBDesired: new FctValue({ destination: 'wei_amount' }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
                liquidity: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            },
        });
    },
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId, provider = _a.provider, account = _a.account, setMethod = _a.setMethod;
        BigNumber.config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: BigNumber.ROUND_FLOOR,
        });
        var helper = new Uniswap({ chainId: chainId, account: account, provider: provider });
        var prevAmountADesiredValue = isVariable(input.methodParams.amountADesired.value)
            ? input.methodParams.amountADesired.estimatedValue
            : input.methodParams.amountADesired.value;
        var prevAmountBDesiredValue = isVariable(input.methodParams.amountBDesired.value)
            ? input.methodParams.amountBDesired.estimatedValue
            : input.methodParams.amountBDesired.value;
        var getValues = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, currencyA, currencyB, amountADesired, amountBDesired, tokenAValue, tokenBValue, isCurrencyANative, isCurrencyBNative, amountADesiredValue, amountBDesiredValue, rates, reserves, amountBValue, amountAValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = input.methodParams, currencyA = _a.currencyA, currencyB = _a.currencyB, amountADesired = _a.amountADesired, amountBDesired = _a.amountBDesired;
                        tokenAValue = currencyA.value;
                        tokenBValue = currencyB.value;
                        if (typeof tokenAValue !== 'string')
                            return [2 /*return*/, { params: {}, error: undefined }];
                        if (typeof tokenBValue !== 'string')
                            return [2 /*return*/, { params: {}, error: undefined }];
                        isCurrencyANative = getIsNative(tokenAValue);
                        isCurrencyBNative = getIsNative(tokenBValue);
                        if (isCurrencyBNative) {
                            return [2 /*return*/, { params: {}, error: "Second token should not be native coin" }];
                        }
                        console.log({ setMethod: setMethod, isCurrencyANative: isCurrencyANative });
                        if (isCurrencyANative) {
                            if (setMethod)
                                setMethod("addLiquidityETH");
                        }
                        else {
                            if (setMethod)
                                setMethod("addLiquidity");
                        }
                        amountADesiredValue = isVariable(amountADesired.value)
                            ? amountADesired.estimatedValue
                            : amountADesired.value;
                        amountBDesiredValue = isVariable(amountBDesired.value)
                            ? amountBDesired.estimatedValue
                            : amountBDesired.value;
                        return [4 /*yield*/, helper.getToken1LiquidityRate({
                                token0: tokenAValue,
                                token1: tokenBValue,
                            })];
                    case 1:
                        rates = _b.sent();
                        if (!rates)
                            return [2 /*return*/, { params: {}, error: 'no rates' }];
                        return [4 /*yield*/, helper.getReserves({
                                token0: tokenAValue,
                                token1: tokenBValue,
                            })];
                    case 2:
                        reserves = _b.sent();
                        if (!reserves)
                            return [2 /*return*/, { params: {}, error: 'no reserves' }];
                        console.log({ rates: rates, reserves: reserves, amountADesiredValue: amountADesiredValue, prevAmountADesiredValue: prevAmountADesiredValue });
                        if (!isVariable(amountBDesired.value) && typeof amountADesiredValue === 'string' && prevAmountADesiredValue !== amountADesiredValue) {
                            prevAmountADesiredValue = amountADesiredValue;
                            amountBValue = new BigNumber(amountADesiredValue).multipliedBy(rates).toString();
                            prevAmountBDesiredValue = amountBValue;
                            console.log({ amountBValue: amountBValue, amountADesiredValue: amountADesiredValue, test2: true });
                            return [2 /*return*/, {
                                    params: {
                                        methodParams: { amountBDesired: amountBValue },
                                    },
                                    error: undefined,
                                }];
                        }
                        if (!isVariable(amountADesired.value) && typeof amountBDesiredValue === 'string' && prevAmountBDesiredValue !== amountBDesiredValue) {
                            prevAmountBDesiredValue = amountBDesiredValue;
                            amountAValue = new BigNumber(amountBDesiredValue).dividedBy(rates).toString();
                            prevAmountADesiredValue = amountAValue;
                            return [2 /*return*/, {
                                    params: {
                                        methodParams: { amountADesired: amountAValue },
                                    },
                                    error: undefined,
                                }];
                        }
                        return [2 /*return*/, { params: {}, error: undefined }];
                }
            });
        }); };
        return {
            get: getValues,
            depParamKeys: [
                'methodParams.currencyA',
                'methodParams.currencyB',
                'methodParams.amountADesired',
                'methodParams.amountBDesired',
            ],
        };
    },
    getParamsOnCreate: function (_a) {
        var chainId = _a.chainId, params = _a.params;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, to, deadline, currencyA, currencyB, amountADesired, amountBDesired, requiredParamsExact, requiredParamsExact_1, requiredParamsExact_1_1, param, requiredParams, requiredParams_1, requiredParams_1_1, param, isCurrencyANative, isCurrencyBNative, plugin_1, plugin;
            var e_1, _c, e_2, _d;
            return __generator(this, function (_e) {
                _b = params.methodParams, to = _b.to, deadline = _b.deadline, currencyA = _b.currencyA, currencyB = _b.currencyB, amountADesired = _b.amountADesired, amountBDesired = _b.amountBDesired;
                requiredParamsExact = [
                    { value: currencyA.value, key: 'currencyA' },
                    { value: currencyB.value, key: 'currencyB' },
                    // { value: amountADesired.value, key: 'amountADesired' },
                    // { value: amountBDesired.value, key: 'amountBDesired' },
                    { value: to.value, key: 'to' },
                ];
                try {
                    for (requiredParamsExact_1 = __values(requiredParamsExact), requiredParamsExact_1_1 = requiredParamsExact_1.next(); !requiredParamsExact_1_1.done; requiredParamsExact_1_1 = requiredParamsExact_1.next()) {
                        param = requiredParamsExact_1_1.value;
                        if (!param.value) {
                            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
                            return [2 /*return*/];
                        }
                        if (typeof param.value !== 'string') {
                            console.error("wrong param ".concat(param.key, ": should be a string"));
                            return [2 /*return*/];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (requiredParamsExact_1_1 && !requiredParamsExact_1_1.done && (_c = requiredParamsExact_1.return)) _c.call(requiredParamsExact_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                requiredParams = [
                    { value: amountADesired.value, key: 'amountADesired' },
                    { value: amountBDesired.value, key: 'amountBDesired' },
                    { value: to.value, key: 'to' },
                ];
                try {
                    for (requiredParams_1 = __values(requiredParams), requiredParams_1_1 = requiredParams_1.next(); !requiredParams_1_1.done; requiredParams_1_1 = requiredParams_1.next()) {
                        param = requiredParams_1_1.value;
                        if (!param.value) {
                            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
                            return [2 /*return*/];
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (requiredParams_1_1 && !requiredParams_1_1.done && (_d = requiredParams_1.return)) _d.call(requiredParams_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                isCurrencyANative = getIsNative(currencyA.value);
                isCurrencyBNative = getIsNative(currencyB.value);
                if (isCurrencyBNative) {
                    console.error("wrong param currencyB: ".concat(currencyB.value));
                    return [2 /*return*/];
                }
                if (isCurrencyANative) {
                    plugin_1 = new AddLiquidityETH({
                        chainId: chainId,
                        initParams: {
                            to: params.to.value,
                            value: amountADesired.value,
                            methodParams: {
                                token: currencyB.value,
                                amountTokenDesired: amountBDesired.value,
                                amountTokenMin: '0',
                                amountETHMin: '0',
                                to: to.value,
                                deadline: deadline.value,
                            },
                        },
                    });
                    return [2 /*return*/, { params: plugin_1.input.params, method: plugin_1.method, gasLimit: '3000000' }];
                }
                plugin = new AddLiquidity({
                    chainId: chainId,
                    initParams: {
                        to: params.to.value,
                        methodParams: {
                            tokenA: currencyA.value,
                            tokenB: currencyB.value,
                            amountADesired: amountADesired.value,
                            amountBDesired: amountBDesired.value,
                            amountAMin: '0',
                            amountBMin: '0',
                            to: to.value,
                            deadline: deadline.value,
                        },
                    },
                });
                return [2 /*return*/, { params: plugin.input.params, method: plugin.method, gasLimit: '3000000' }];
            });
        });
    },
    requiredApprovals: function (params) { return [
        {
            to: params.methodParams.currencyA.value,
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value },
            method: 'approve',
            protocol: 'ERC20',
        },
        {
            to: params.methodParams.currencyB.value,
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value },
            method: 'approve',
            protocol: 'ERC20',
        },
    ]; },
    // async assetFlow(params, chainId, walletAddress, vaultAddress, provider, method) {
    //   const {
    //     to,
    //     methodParams: { currencyA, currencyB, amountADesired, amountBDesired },
    //   } = params
    //   if (
    //     !currencyA.value ||
    //     !currencyB.value ||
    //     !to.value ||
    //     !amountADesired.value ||
    //     !amountBDesired.value ||
    //     !vaultAddress
    //   )
    //     return []
    //   if (
    //     typeof amountADesired.value !== 'string' ||
    //     typeof amountBDesired.value !== 'string' ||
    //     typeof currencyA.value !== 'string' ||
    //     typeof currencyB.value !== 'string' ||
    //     typeof to.value !== 'string'
    //   )
    //     return []
    //   // Generate pool address from tokenA and tokenB
    //   const token0 = currencyA.value
    //   const token1 = currencyB.value
    //   const pairAddress = new Uniswap({ chainId }).getPairAddress({
    //     token0,
    //     token1,
    //   })
    //   const Pair = new ethers.Contract(
    //     pairAddress,
    //     ['function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)'],
    //     provider
    //   )
    //   const reserves = await Pair.getReserves()
    //   function sqrt(n: bigint): bigint {
    //     if (n < 0) {
    //       throw 'Square root of negative numbers is not supported'
    //     }
    //     if (n < 2n) {
    //       return n
    //     }
    //     function newtonIteration(n: bigint, x0: bigint): bigint {
    //       const x1 = (n / x0 + x0) >> 1n
    //       if (x0 === x1 || x0 === x1 - 1n) {
    //         return x0
    //       }
    //       return newtonIteration(n, x1)
    //     }
    //     return newtonIteration(n, 1n)
    //   }
    //   function calculateLPTokens(
    //     reserveA: bigint,
    //     reserveB: bigint,
    //     previousReserveA: bigint,
    //     previousReserveB: bigint
    //   ): bigint {
    //     return sqrt(reserveA * reserveB) - sqrt(previousReserveA * previousReserveB)
    //   }
    //   const lpTokenAmount = calculateLPTokens(
    //     BigInt(reserves.reserve0) + BigInt(amountADesired.value),
    //     BigInt(reserves.reserve1) + BigInt(amountBDesired.value),
    //     BigInt(reserves.reserve0),
    //     BigInt(reserves.reserve1)
    //   )
    //   const assetFlow = [
    //     {
    //       address: vaultAddress,
    //       toSpend: [
    //         {
    //           token: currencyA.value,
    //           amount: amountADesired.value,
    //         },
    //         {
    //           token: currencyB.value,
    //           amount: amountBDesired.value,
    //         },
    //       ],
    //       toReceive: [
    //         {
    //           token: pairAddress,
    //           amount: lpTokenAmount.toString(),
    //         },
    //       ],
    //     },
    //   ]
    //   return assetFlow
    // },
});
